import { CustomSettingsIcon, GlobalSettingsIcon } from '@reveni-io/reveni-ui'

export const getSettingTypes = theme => {
  return {
    global: {
      icon: <GlobalSettingsIcon color={theme.colors.success.hover} />,
      title: 'Configuración global',
      description:
        'Esta página utiliza la configuración global de tu organización. Para realizar cambios, actualiza esa configuración o elige configurar ajustes personalizados solo para esta página.',
    },
    custom: {
      icon: <CustomSettingsIcon color={theme.colors.info.onSurface} />,
      title: 'Configuración personalizada',
      description:
        'Esta página utiliza su propia configuración personalizada. Para volver a la configuración global de tu organización, desactiva la configuración personalizada de esta página.',
    },
  }
}
